import { render } from "./MyPoolInvsetmentFiat.vue?vue&type=template&id=7a4f3c56&ts=true"
import script from "./MyPoolInvsetmentFiat.vue?vue&type=script&lang=ts"
export * from "./MyPoolInvsetmentFiat.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__